import { useRef } from "react";
import React, { useEffect, useState, useCallback } from "react";
import { faCheck, faTimes, faInfoCircle, faBlackboard, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';


const MOBILE_REGEX = /^[0-9]{10}$/;
const AMOUNT_REGEX = /^[0-9]$/;

const EDIT_GURUDAKSHINA_URL = "update-gurudakshina";


const AdminEditGurudakshina = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
  };
  const axiosPrivate = useAxiosPrivate();
  const nameRef = useRef();
  const mobileRef = useRef();
  const amountRef = useRef();
  const chequeNoRef = useRef();

  const errRef = useRef();
  const sucssRef = useRef();

  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [house_name, setHouse_name] = useState("");
  const [originalDate, setOriginalDate] = useState("");
  const [pan, setPan] = useState("");
  const [pincode, setPincode] = useState("");
  const [postOffice, setPostOffice] = useState("");
  const [error, setError] = useState('');


  const [validMobile, setValidMobile] = useState(false);
  const [validName, setValidName] = useState(false);
  const [validAmount, setValidAmount] = useState(false);
  const [validChequeNo, setValidChequeNo] = useState(false);


  const [chequeNoFocus, setChequeNoFocus] = useState(false);
  const [amountFocus, setAmountFocus] = useState(false);
  const [mobileFocus, setMobileFocus] = useState(false);
  const [nameFocus, setNameFocus] = useState(false);
  const { auth } = useAuth();
  const [selectedSakha, setSelectedSakha] = useState('');

  const [selectedShreni, setSelectedShreni] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [bank, setBank] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [isCheque, setIsCheque] = useState(false);

  const [sakhaList, setSakhaList] = useState([]);
  const [shreniList, setShreniList] = useState([]);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const { gurudakshinaId, sthanId } = useParams();
  const [gurudakshinas, setGurudakshinas] = useState(null);
  const [loading, setLoading] = useState(true);

  const [proudaSubmitted, setProudaSubmitted] = useState(false);
  const [vidyarthiSamyukthaSubmitted, setVidyarthiSamyukthaSubmitted] = useState(false);
  const [vidyarthiTharunaSubmitted, setVidyarthiTharunaSubmitted] = useState(false);
  const [vyavasayiTharunaSubmitted, setVyavasayiTharunaSubmitted] = useState(false);
  const [FinalSubmissionList, setFinalSubmissionList] = useState([]);
  const [Finilized, setFinilized] = useState([]);
  const [sakhaWarning, setSakhaWarning] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const navigate = useNavigate();
  // const [success, setSuccess] = useState(false);

  const [age, setAge] = useState("");
  const [isPrathyajithVolunteer, setIsPrathyajithVolunteer] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [studentDisabled, setStudentDisabled] = useState(false);

  const [postOfficeSuggestions, setPostOfficeSuggestions] = useState([]);
  const [pincodeSuggestions, setPincodeSuggestions] = useState([]);

  const [showPostOfficeDropdown, setShowPostOfficeDropdown] = useState(false);
  const [showPincodeDropdown, setShowPincodeDropdown] = useState(false);

  const [submittedData, setSubmittedData] = useState("");


  const getShreni = (age) => {
    const ageNum = Number(age);

    if (ageNum > 40) {
      return "Prouda";
    } else if (ageNum >= 16) {
      return "Tharuna";
    } else if (ageNum >= 11) {
      return "Bala";
    } else {
      return "Sisu";
    }
  };

  const updateStudentStatus = (age) => {
    const ageNum = Number(age);

    if (ageNum >= 0 && ageNum <= 2) {
      // 0-2: Disabled, Unchecked
      setIsStudent(false);
      setStudentDisabled(true);
    } else if (ageNum >= 3 && ageNum <= 15) {
      // 3-15: Disabled, Checked
      setIsStudent(true);
      setStudentDisabled(true);
    } else if (ageNum >= 16 && ageNum <= 40) {
      // 16-40: Enabled, Unchecked
      setIsStudent(false);
      setStudentDisabled(false);
    } else if (ageNum > 40) {
      // 40+: Disabled, Unchecked
      setIsStudent(false);
      setStudentDisabled(true);
    } else {
      // No age entered
      setIsStudent(false);
      setStudentDisabled(false);
    }
  };


  const searchPincode = async (value) => {
    if (value.length < 2) {
      setPincodeSuggestions([]);
      return;
    }

    try {
      const res = await axiosPrivate.get(`get-post-office?pincode=${value}`);
      setPincodeSuggestions(res.data || []);
      setShowPincodeDropdown(true);
    } catch (err) {
      setPincodeSuggestions([]);
    }
  };

  const searchPostOffice = async (value) => {
    if (value.length < 2) {
      setPostOfficeSuggestions([]);
      return;
    }

    try {
      const res = await axiosPrivate.get(
        `get-post-office?office=${encodeURIComponent(value)}`
      );

      setPostOfficeSuggestions(res.data || []);
      setShowPostOfficeDropdown(true);
    } catch (err) {
      setPostOfficeSuggestions([]);
    }
  };


  let formattedDate = "";

  if (originalDate) {
    const [year, month, day] = originalDate.split("-");
    formattedDate = `${day}/${month}/${year}`;
  }

  const handleSakhaChange = (value) => {
    setSelectedSakha(value);

    let finalizedValue = false;

    if (value === "Prouda") {
      finalizedValue = proudaSubmitted;
    } else if (value === "Vidyarthi Samyuktha") {
      finalizedValue = vidyarthiSamyukthaSubmitted;
    } else if (value === "Vidyarthi Tharuna") {
      finalizedValue = vidyarthiTharunaSubmitted;
    } else if (value === "Vyavasayi Tharuna") {
      finalizedValue = vyavasayiTharunaSubmitted;
    }

    setFinilized(finalizedValue);
    setSakhaWarning(finalizedValue);
  };

  const fetchFinalSubmissionAndGurudakshina = useCallback(async () => {
    setError(null);
    setLoading(true);

    try {
      // 1. Fetch final submission list
      const finalResponse = await axiosPrivate.get(`list-final-submissions?sthan_id=${sthanId}`, {
        withCredentials: true,
      });
      const finalData = finalResponse.data;


      setFinalSubmissionList(finalData);

      const sakhaMap = {
        "Prouda": setProudaSubmitted,
        "Vidyarthi Samyuktha": setVidyarthiSamyukthaSubmitted,
        "Vidyarthi Tharuna": setVidyarthiTharunaSubmitted,
        "Vyavasayi Tharuna": setVyavasayiTharunaSubmitted,
      };

      // Store submission status for quick lookup
      const sakhaSubmittedStatus = {};

      finalData.forEach(item => {
        if (sakhaMap[item.sakha]) {
          sakhaMap[item.sakha](item.isSubmitted);
          sakhaSubmittedStatus[item.sakha] = item.isSubmitted;
        }
      });

      // 2. Fetch Gurudakshina
      const gurudakshinaResponse = await axiosPrivate.get(`get-gurudakshina?id=${gurudakshinaId}`, {
        withCredentials: true,
      });

      const gData = gurudakshinaResponse.data;

      // Set sakha and check finalization status
      const selectedSakha = gData.sakha;
      setSelectedSakha(selectedSakha);

      const isFinalized = sakhaSubmittedStatus[selectedSakha] || false;
      setFinilized(isFinalized);
      setSakhaWarning(isFinalized);

      // Set other Gurudakshina fields
      setSelectedShreni(gData.shreni);
      setName(gData.name);
      setMobile(gData.mobile);
      setAmount(gData.amount);
      setPan(gData.pan);
      setSelectedPaymentMode(gData.payment_mode);
      setSelectedBank(gData.bank);
      setChequeNo(gData.cheque_no);
      setHouse_name(gData.house_name);
      setPincode(gData.pincode);
      setPostOffice(gData.post_office);
      setAge(gData.age);
      setIsStudent(gData.vidyarthi);
      setIsPrathyajithVolunteer(gData.oauth_taken)

      const formattedDate = gData.date_of_samarppan?.split("T")[0];
      setOriginalDate(formattedDate);

      setLoading(false);
    } catch (error) {
      console.error("Error in fetchFinalSubmissionAndGurudakshina:", error);
      setError(
        error?.response?.data?.message?.toString() || error?.message || "No data available."
      );
      setLoading(false);
    }
  }, [axiosPrivate, sthanId, gurudakshinaId]);



  useEffect(() => {
    fetchFinalSubmissionAndGurudakshina();
  }, []);

  const fetchSakhaList = async () => {
    try {
      // Uncomment this when using real API:
      const res = await axiosPrivate.get('get-sakhas');
      setSakhaList(res.data);

    } catch (err) {
      console.error("Failed to fetch sakhas", err);
      // fallback data on error
    }
  };






  const fetchShreniList = async () => {
    try {
      // Uncomment this when using real API:
      const res = await axiosPrivate.get('get-shrenies');
      setShreniList(res.data);

    } catch (err) {
      console.error("Failed to fetch Shreni", err);
      // fallback data on error
      setShreniList([
        "Bala",
        "Tharuna",
        "Prouda"
      ]);
    }
  };


  const fetchPaymentMode = async () => {
    try {
      // Uncomment this when using real API:
      // const res = await axios.get('API_URL/list-PaymentMode');
      // setShreniList(res.data);

      // Mock data if API fails or during development:
      setPaymentModeList([
        "Cheque",
        "Cash",
      ]);
    } catch (err) {
      console.error("Failed to fetch Payment Modes", err);
      // fallback data on error
      setPaymentModeList([
        "Cheque",
        "Cash",
      ]);
    }
  };


  const fetchBankList = async () => {
    try {
      // Uncomment this when using real API:
      // const res = await axios.get('API_URL/list-PaymentMode');
      // setShreniList(res.data);

      // Mock data if API fails or during development:
      setBankList([
        "Allahabad Bank",
        "Andhra Bank",
        "Axis Bank",
        "Bank of Baroda",
        "Bank of India",
        "Bank of Maharashtra",
        "Canara Bank",
        "Corporation Bank",
        "CSB Bank(formerly known as Catholic Syrian Bank Ltd)",
        "Dhanlaxmi Bank(known as Dhanalakshmi Bank before name change in 2010)",
        "ESAF Small Finance Bank",
        "Federal Bank(In 1931 originally known as Travancore Federal Bank)",
        "Kerala Bank",
        "Kerala Gramin Bank",
        "ICICI Bank",
        "HDFC Bank",
        "Kotak Mahindra Bank",
        "Punjab National Bank",
        "South Indian Bank",
        "State Bank of India",
      ]);
    } catch (err) {
      console.error("Failed to fetch Bank List", err);
      // fallback data on error
    }
  };



  useEffect(() => {
    fetchPaymentMode();
  }, []);

  useEffect(() => {
    fetchSakhaList();
  }, []);
  useEffect(() => {
    fetchShreniList();
  }, []);


  useEffect(() => {
    nameRef.current?.focus();
  }, []);



  useEffect(() => {
    const isValid = /^(?!.*\d).{2,}$/.test(name);
    // (?!.*\d) → negative lookahead, ensures no digits 0–9
    // .{2,}    → any 2 or more characters (except newlines)
    setValidName(isValid);
  }, [name]);

  useEffect(() => {
    setValidMobile(MOBILE_REGEX.test(mobile));
  }, [mobile]);

  useEffect(() => {
    setValidAmount(AMOUNT_REGEX.test(amount));
  }, [amount]);



  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var data = JSON.stringify({
        id: gurudakshinaId,
        sthan_id: sthanId,
        name,
        sakha: selectedSakha,
        shreni: selectedShreni,
        amount,
        payment_mode: selectedPaymentMode,
        mobile: mobile,
        cheque_no: chequeNo,
        bank: selectedBank,
        house_name,
        date_of_samarppan: formattedDate,
        pan: pan,
        pincode: pincode,
        post_office: postOffice,

        age: age,
        oauth_taken: isPrathyajithVolunteer,
        vidyarthi: isStudent
      });

      // setSubmittedData(data);


      const response = await axiosPrivate.post(EDIT_GURUDAKSHINA_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }


  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };


  return (
    <>
      <Container>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}


        {/* <pre
          style={{
            whiteSpace: "pre-wrap",
            background: "#f8f9fa",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "5px",
            color: "green"
          }}
        >
          {submittedData}
        </pre> */}
        <section className="empbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={sucssRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>



          <div className="wrapper wrapper2 newraps2">
            <form>
              <center><h5 class="newraphead">Edit Gurudhakshina</h5></center>

              <Row>
                <Col md={6}>
                  <Form.Label className="newformstyle newstylever">Date</Form.Label>
                  <div className="input-box arthik_input-box newinpdivs">
                    <input
                      // disabled={Finilized}
                      type="date"
                      id="date"
                      onChange={(e) => setOriginalDate(e.target.value)}
                      value={originalDate}
                      required
                    />
                  </div>
                </Col>

                <Col md={6}>
                  <Form.Label className="newformstyle newstylever">Name</Form.Label>
                  <div className="input-box arthik_input-box newinpdivs">
                    <input
                      // disabled={Finilized}
                      type="text"
                      id="name"
                      className="newinpstyle"
                      placeholder="Enter Name"
                      autoComplete="off"
                      ref={nameRef}
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                      required
                      aria-invalid={validName ? "false" : "true"}
                      aria-describedby="namenote"
                      onFocus={() => setNameFocus(true)}
                      onBlur={() => setNameFocus(false)}
                    />
                    <p
                      id="namenote"
                      className={
                        nameFocus && name && !validName ? "instructions" : "offscreen"
                      }
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                      Name is required!
                    </p>
                  </div>
                </Col>

                <Col md={6}>
                  <Form.Label className="newformstyle newstylever">House name</Form.Label>
                  <div className="input-box arthik_input-box newinpdivs">
                    <input
                      // disabled={Finilized}
                      type="text"
                      id="house_name"
                      className="newinpstyle"
                      placeholder="Enter House name"
                      autoComplete="off"
                      onChange={(e) => setHouse_name(e.target.value)}
                      value={house_name}
                      required
                    />
                  </div>
                </Col>


                <Col md={6}>
                  <Form.Label className="newformstyle newstylever">Select Ultsavam</Form.Label>
                  <div className="input-box arthik_input-box newinpdivs">
                    <select
                      id="sakhaSelect"
                      className="form-control guruselect"
                      value={selectedSakha}
                      onChange={(e) => handleSakhaChange(e.target.value)}
                    >
                      <option value="">-- Select Ultsavam --</option>
                      {sakhaList.map((sakha, index) => (
                        <option key={index} value={sakha}>{sakha}</option>
                      ))}
                    </select>

                    {sakhaWarning && (
                      <small className="text-danger mt-1">{selectedSakha} Finalized</small>
                    )}
                  </div>
                </Col>


                {/* <Col md={6} >
                  <Form.Label className="newformstyle newstylever">Select Shreni</Form.Label>
                  <div className="input-box arthik_input-box newinpdivs">
                    <select
                      // disabled={Finilized}
                      id="shreniSelect"
                      className="form-control guruselect"
                      value={selectedShreni}
                      onChange={(e) => setSelectedShreni(e.target.value)}
                    >
                      <option value="">-- Select Shreni --</option>
                      {shreniList.map((shreni, index) => (
                        <option key={index} value={shreni}>{shreni}</option>
                      ))}
                    </select>
                  </div>
                </Col> */}
                <Col md={2}>
                  <Form.Label className="newformstyle newstylever">Age</Form.Label>
                  <div className="arthik_input-box">
                    <input
                      disabled={Finilized}
                      // type="tel"
                      id="age"
                      className="telstyle newinpstyle"
                      placeholder="Enter Age"
                      autoComplete="off"
                      // onChange={(e) => {
                      //   const value = e.target.value.replace(/\D/g, '');

                      //   setAge(value);

                      //   if (value) {
                      //     setSelectedShreni(getShreni(value));
                      //   } else {
                      //     setSelectedShreni("");
                      //   }
                      // }}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");

                        setAge(value);

                        if (value) {
                          setSelectedShreni(getShreni(value));
                          updateStudentStatus(value);
                        } else {
                          setSelectedShreni("");
                          updateStudentStatus("");
                        }
                      }}
                      value={age}
                      required
                      disabled={Finilized}
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      id="isStudent"
                      className="form-check-input"
                      checked={isStudent}
                      disabled={studentDisabled || Finilized}
                      onChange={(e) => setIsStudent(e.target.checked)}
                    />
                    <label className="form-check-label studentClass" htmlFor="isStudent">
                      Student
                    </label>
                  </div>
                </Col>
                <Col md={2}>
                  <Form.Label className="newformstyle newstylever">Shreni</Form.Label>
                  <div className="arthik_input-box">
                    <select
                      id="shreniSelect"
                      className="form-control guruselect"
                      value={selectedShreni}
                      onChange={(e) => setSelectedShreni(e.target.value)}
                      // disabled={Finilized}
                      disabled
                    >
                      <option value="">-- Select Shreni --</option>
                      {shreniList.map((shreni, index) => (
                        <option key={index} value={shreni}>
                          {shreni}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>




                <Col md={6}>
                  <Form.Label className="newformstyle newstylever">Mobile number</Form.Label>
                  <div className="input-box arthik_input-box newinpdivs">
                    <input
                      // disabled={Finilized}
                      type="tel"
                      id="mobile"
                      className="telstyle newinpstyle"
                      placeholder="Enter Mobile number"
                      autoComplete="off"
                      ref={mobileRef}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // remove non-digits
                        setMobile(value);
                      }}
                      value={mobile}
                      required
                      aria-invalid={validMobile ? "false" : "true"}
                      aria-describedby="namenote"
                      onFocus={() => setMobileFocus(true)}
                      onBlur={() => setMobileFocus(false)}
                    />
                    <p
                      id="namenote"
                      className={
                        mobileFocus && mobile && !validMobile ? "instructions" : "offscreen"
                      }
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                      Mobile number is required!.
                    </p>
                  </div>

                </Col>
                <Col md={6}>
                  <Form.Label className="newformstyle newstylever">Amount</Form.Label>
                  <div className="input-box arthik_input-box newinpdivs">
                    <input
                      // disabled={Finilized}
                      type="text"
                      id="amount"
                      className="newinpstyle"
                      placeholder="Enter Amount"
                      autoComplete="off"
                      ref={amountRef}
                      // onChange={(e) => {
                      //   let value = e.target.value;
                      //   // Allow only numbers and one dot
                      //   value = value.replace(/[^0-9.]/g, ''); // remove non-digits/non-dot
                      //   const parts = value.split('.');
                      //   if (parts.length > 2) {
                      //     // If more than one dot, remove extras
                      //     value = parts[0] + '.' + parts[1];
                      //   }
                      //   setAmount(value);
                      // }}
                      onChange={(e) => {
                        let value = e.target.value || "";

                        value = value.replace(/[^0-9.]/g, "");

                        const parts = value.split(".");
                        if (parts.length > 2) {
                          value = parts[0] + "." + parts[1];
                        }

                        console.log("Typing:", value);

                        setAmount(value);
                      }}
                      value={amount}
                      required
                      aria-describedby="amountnote"
                      onFocus={() => setAmountFocus(true)}
                      onBlur={() => setAmountFocus(false)}
                    />
                    <p
                      id="amountnote"
                      className={
                        amountFocus && amount ? "instructions" : "offscreen"
                      }
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                      Amount is required!.
                    </p>
                  </div>
                </Col>

                {parseFloat(amount) > 1999 && (
                  <Col md={6}>
                    <Form.Label className="newformstyle newstylever">PAN</Form.Label>
                    <div className="input-box arthik_input-box newinpdivs">
                      <input
                        // disabled={Finilized}
                        type="text"
                        id="pan"
                        className="newinpstyle"
                        placeholder="Enter PAN"
                        autoComplete="off"
                        onChange={(e) => setPan(e.target.value)}
                        value={pan}
                      />
                    </div>
                  </Col>
                )}

                {/* <Col md={6}>
                  <Form.Label className="newformstyle newstylever">Select Payment Mode</Form.Label>
                  <div className="input-box arthik_input-box newinpdivs">
                    <select
                      // disabled={Finilized}
                      id="shrenSelect"
                      className="form-control guruselect"
                      value={selectedPaymentMode}
                      onChange={(e) => setSelectedPaymentMode(e.target.value)}
                    >
                      <option value="">-- Select Payment Mode --</option>
                      {paymentModeList.map((paymentMode, index) => (
                        <option key={index} value={paymentMode}>
                          {paymentMode}
                        </option>
                      ))}
                    </select>

                    {error && <p style={{ color: 'red' }}>{error}</p>}
                  </div>
                </Col> */}

                <Col md={1}>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="paymentMode"
                      className="form-check-input"
                      checked={isCheque}
                      disabled={Finilized}
                      onChange={(e) => setIsCheque(e.target.checked)}
                    />
                    <label className="form-check-label prathyajithClass" htmlFor="paymentMode">
                      Cheque Payment
                    </label>
                  </div>
                </Col>



                <Col md={2}>
                  {isCheque && (
                    <>
                      <Form.Label className="newformstyle newstylever">
                        Bank name
                      </Form.Label>

                      <div className="input-box arthik_input-box newinpdivs">
                        <input
                          // disabled={Finilized}
                          type="text"
                          id="bankSelect"
                          className="newinpstyle"
                          placeholder="Enter Bank name"
                          autoComplete="off"
                          onChange={(e) => setSelectedBank(e.target.value)}
                          value={selectedBank}
                          required
                          aria-describedby="namenote"
                          onFocus={() => setChequeNoFocus(true)}
                          onBlur={() => setChequeNoFocus(false)}
                        />
                      </div>
                    </>
                  )}
                </Col>

                <Col md={2}>
                  {isCheque && (
                    <>
                      <Form.Label className="newformstyle newstylever">Cheque no</Form.Label>
                      <div className="input-box arthik_input-box newinpdivs">
                        <input
                          // disabled={Finilized}
                          type="text"
                          id="cheque_no"
                          className="newinpstyle"
                          placeholder="Enter Cheque no"
                          autoComplete="off"
                          ref={chequeNoRef}
                          onChange={(e) => setChequeNo(e.target.value)}
                          value={chequeNo}
                          required
                          aria-describedby="namenote"
                          onFocus={() => setChequeNoFocus(true)}
                          onBlur={() => setChequeNoFocus(false)}
                        />
                      </div>
                    </>
                  )}
                </Col>





                {house_name.trim() !== "" && (
                  <Col md={3}>
                    <Form.Label className="newformstyle newstylever">Pincode</Form.Label>
                    <div className="input-box arthik_input-box">
                      <input
                        disabled={Finilized}
                        type="text"
                        id="pincode"
                        className="newinpstyle Margin2"
                        placeholder="Enter Pincode"
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");

                          if (value.length <= 6) {
                            setPincode(value);
                            searchPincode(value);
                          }
                        }}
                        value={pincode}
                        inputMode="numeric"
                        maxLength={6}
                      />

                      {showPincodeDropdown && pincodeSuggestions.length > 0 && (
                        <div className="dropdown-menu show w-100">

                          {pincodeSuggestions.map((item, index) => (
                            <button
                              type="button"
                              key={index}
                              className="dropdown-item"
                              onClick={() => {
                                setPincode(item.pincode);
                                setPostOffice(item.officename);
                                setShowPincodeDropdown(false);
                              }}
                            >
                              <strong>{item.pincode}</strong> - {item.officename}
                              <br />
                              <small>{item.district}</small>
                            </button>
                          ))}

                        </div>
                      )}
                    </div>
                  </Col>
                )}



                {house_name.trim() !== "" && (
                  <Col md={3}>
                    <Form.Label className="newformstyle newstylever">Post office</Form.Label>
                    <div className="input-box arthik_input-box">
                      <input
                        disabled={Finilized}
                        type="text"
                        id="post_office"
                        className="newinpstyle"
                        placeholder="Enter Post office"
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value;
                          setPostOffice(value);
                          searchPostOffice(value);
                        }}
                        value={postOffice}
                      />
                      {showPostOfficeDropdown && postOfficeSuggestions.length > 0 && (
                        <div className="dropdown-menu show w-100">

                          {postOfficeSuggestions.map((item, index) => (
                            <button
                              type="button"
                              key={index}
                              className="dropdown-item"
                              onClick={() => {
                                setPostOffice(item.officename);
                                setPincode(item.pincode);
                                setShowPostOfficeDropdown(false);
                              }}
                            >
                              <strong>{item.officename}</strong>
                              <br />
                              <small>
                                {item.pincode} • {item.district}
                              </small>
                            </button>
                          ))}

                        </div>
                      )}
                    </div>
                  </Col>
                )}


                {Number(age) >= 18 && (
                  <Col md={12}>
                    <div className="form-check mb-3">
                      <input
                        type="checkbox"
                        id="isPrathyajithVolunteer"
                        className="form-check-input"
                        checked={isPrathyajithVolunteer}
                        onChange={(e) => setIsPrathyajithVolunteer(e.target.checked)}
                        disabled={Finilized}
                      />
                      <label
                        className="form-check-label prathyajithClass"
                        htmlFor="isPrathyajithVolunteer"
                      >
                        Prathinjith swayamsevak
                      </label>
                    </div>
                  </Col>
                )}




                <Col md={12}>
                  <button
                    type="button"
                    className="btn"
                    style={{ color: "black" }}
                    onClick={handleSubmit}
                    disabled={
                      !validName ||
                      !selectedSakha ||
                      !selectedShreni ||
                      !amount ||
                      !selectedPaymentMode ||
                      !originalDate ||
                      !house_name ||
                      Finilized
                    }
                  >
                    Submit
                  </button>
                </Col>
              </Row>
            </form>

          </div>

        </section>
        {/* )} */}
      </Container >
    </>
  );
};

export default AdminEditGurudakshina;
